(function () {

    'use strict';

    angular
        .module('app.core')
        .service('ApiService', [
            'API_CONFIG',
            '$http',
            '$cacheFactory',
            '$interpolate',
            'CommonUtil',
			ApiService
        ]);

    function ApiService(API_CONFIG, $http, $cacheFactory, $interpolate, commonUtil) {
        var service = this;
        var apiServiceCache = $cacheFactory('ApiServiceCache');

        service.getLocations = getLocations;
        service.getLocationByCode = getLocationByCode;
        service.getStaticLocations = getStaticLocations;
        service.getLanguages = getLanguages;
        service.getLanguageByCode = getLanguageByCode;
        service.getTranslationByCode = getTranslationByCode;
        service.getSearchResultOptions = getSearchResultOptions;
        service.getWinnowingValues = getWinnowingValues;
        service.sendContactUsEmail = sendContactUsEmail;

        function getLocations(langCode) {
            var url = $interpolate(API_CONFIG.endpoints.BI_SERVICE_API + '{{plId}}/locations/{{langCode}}.json');
            url = url({
              plId : API_CONFIG.PRIVATE_LABEL_ID,
              langCode : langCode
            });
            return $http.get(url, {
              transformResponse : function(data, headersGetter) {
                var locations = angular.fromJson(data).locations;
                var result = [];
                var loc;
                for (var i = 0; i < locations.length; i++) {
                  loc = locations[i];
                  if (loc.isEnabled) {
                      if (loc.registerToBidUrl) {
                          loc.registerToBidUrl += ((loc.registerToBidUrl.indexOf('?') == -1 ? '?' : '&') + 'locid=' +  loc.locationId);
                      }
                      if (loc.onlineBuyerRegistrationFormUrl) {
                          loc.onlineBuyerRegistrationFormUrl += ((loc.onlineBuyerRegistrationFormUrl.indexOf('?') == -1 ? '?' : '&') + 'locid=' +  loc.locationId);
                      }

                      if (loc.watchLiveAsGuestUrl) {
                          loc.watchLiveAsGuestUrl += ((loc.watchLiveAsGuestUrl.indexOf('?') == -1 ? '?' : '&') + 'locid=' +  loc.locationId);
                      }

                      if (loc.userLogInUrl) {
                          loc.userLogInUrl += ((loc.userLogInUrl.indexOf('?') == -1 ? '?' : '&') + 'locid=' +  loc.locationId);
                      }

                    result.push(loc);
                  }
                }
                return result;
              },
              cache : apiServiceCache
            });
        }

        function getLocationByCode(locations, locCode) {
            return commonUtil.findById(locations, 'locationCode', locCode);
        }

        function getStaticLocations(langCode) {
        	var url = $interpolate(API_CONFIG.endpoints.BI_SERVICE_API + '{{plId}}/staticlocations/{{langCode}}.json');
        	url = url({
            	plId : API_CONFIG.PRIVATE_LABEL_ID,
            	langCode : langCode
            });
        	return $http.get(url, {
                transformResponse : function(data, headersGetter) {
                    var staticLocations = angular.fromJson(data).staticLocations;
                    var result = [];
                    var loc;
                    for (var i = 0; i < staticLocations.length; i++) {
                        loc = staticLocations[i];
                        if (loc.isEnabled) {
                            if (loc.registerToBidUrl) {
                                loc.registerToBidUrl += ((loc.registerToBidUrl.indexOf('?') == -1 ? '?' : '&') + 'locid=' +  loc.locationId);
                            }
                            if (loc.onlineBuyerRegistrationFormUrl) {
                                loc.onlineBuyerRegistrationFormUrl += ((loc.onlineBuyerRegistrationFormUrl.indexOf('?')== -1 ? '?' : '&') + 'locid=' +  loc.locationId);
                            }

                            if (loc.watchLiveAsGuestUrl) {
                                loc.watchLiveAsGuestUrl += ((loc.watchLiveAsGuestUrl.indexOf('?') == -1 ? '?' : '&') + 'locid=' +  loc.locationId);
                            }

                            if (loc.userLogInUrl) {
                                loc.userLogInUrl += ((loc.userLogInUrl.indexOf('?') == -1 ? '?' : '&') + 'locid=' +  loc.locationId);
                            }

                            result.push(loc);
                        }
                    }
                    return result;
    			},
                cache : apiServiceCache
            });
        }

        function getLanguages() {
        	var url = $interpolate(API_CONFIG.endpoints.BI_SERVICE_API + '{{plId}}/languages.json');
        	url = url({
            	plId : API_CONFIG.PRIVATE_LABEL_ID
            });
        	return $http.get(url, {
                transformResponse : function(data, headersGetter) {
    				return angular.fromJson(data).languages;
    			},
                cache : apiServiceCache
            });
        }

        function getLanguageByCode(languages, langCode) {
            return commonUtil.findById(languages, 'languageCode', langCode);
        }

        function getTranslationByCode(langCode) {
        	var url = $interpolate(API_CONFIG.endpoints.BI_SERVICE_API + '{{plId}}/translations/{{langCode}}.json');
        	url = url({
            	plId : API_CONFIG.PRIVATE_LABEL_ID,
            	langCode : langCode
            });
        	return $http.get(url, {
                transformResponse : function(data, headersGetter) {
    				return angular.fromJson(data).translations;
    			},
                cache : apiServiceCache
            });
        }

        function getSearchResultOptions() {
        	var url = $interpolate(API_CONFIG.endpoints.BI_SERVICE_API + '{{plId}}/searchresultoptions.json');
        	url = url({
            	plId : API_CONFIG.PRIVATE_LABEL_ID
            });
			return $http.get(url, {
				cache : apiServiceCache
			});
        }

        function getWinnowingValues() {
        	var url = $interpolate(API_CONFIG.endpoints.BI_SERVICE_API + '{{plId}}/srpWinnowingValues.json');
        	url = url({
            	plId : API_CONFIG.PRIVATE_LABEL_ID
            });
            return $http.get(url, {
                cache : apiServiceCache
            });
        }

        function sendContactUsEmail(toEmail, cus) {
        	var url = $interpolate(API_CONFIG.endpoints.BI_SERVICE_API + '{{plId}}/cusnotification');
        	url = url({
            	plId : API_CONFIG.PRIVATE_LABEL_ID
            });
        	return $http.post(url, {
                toEmail: toEmail,
                subject: cus.subject,
                firstName: cus.firstName,
                lastName: cus.lastName,
                phone: cus.phoneAndAreCode,
                email: cus.email,
                message: cus.message,
                newsletter: cus.news
            });
        }
    }

})();



// WEBPACK FOOTER //
// ./app/core/service/ApiService.js